var _defs, _path, _path2, _line, _path3, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottocutround01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-11,.cls-10{fill:#fff;}.cls-11,.cls-9,.cls-8{stroke:#000;stroke-miterlimit:10;}.cls-11{stroke-width:3px;}.cls-9,.cls-8{fill:none;}.cls-8{stroke-dasharray:4.02 4.02;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M370.67,174.18V277.29a65.33,65.33,0,0,1-65.34,65.33H138.67a65.33,65.33,0,0,1-65.34-65.33V174.18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M366.67,174.44V274.78a63.59,63.59,0,0,1-63.58,63.58H140.91a63.59,63.59,0,0,1-63.58-63.58V174.44"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 366.67,
    y1: 174.44,
    x2: 366.67,
    y2: 176.44
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M366.67,180.46v94.32a63.59,63.59,0,0,1-63.58,63.58H140.91a63.59,63.59,0,0,1-63.58-63.58V178.45"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 77.33,
    y1: 176.44,
    x2: 77.33,
    y2: 174.44
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottocutround01);
export default __webpack_public_path__ + "static/media/BOTTO CUT ROUND-01.9249c8593551533e4f613d7dd01bf382.svg";
export { ForwardRef as ReactComponent };